import { Box, Button, Typography, Tooltip as TooltipMui } from '@mui/material'
import { Icon as Iconify } from '@iconify/react'
import { appColors } from 'utils'

const ResetFiltersButton = ({ filterApplied, gridApi = null, posAdjustment = '0px', onFilterRemoved = null, controlBarVersion = false}) => {
  return (
    <TooltipMui title={filterApplied ? 'Filters applied. Click to reset' : ''} arrow placement='top'>
      <Button
        className='reset-button'
        onClick={() => {
          if (!gridApi?.current) return
          gridApi.current.setFilterModel(null)
          if (onFilterRemoved) onFilterRemoved()
        }}
        disabled={!filterApplied}
        sx={{
          color: appColors?.dirNptColor,
          width: 'auto',
          justifyContent: 'center',
          textTransform: 'none',
          position: 'relative',
          right: posAdjustment,
          border: controlBarVersion && filterApplied ? `1px solid ${appColors?.dirNptColor}` : 'none',
          boxSizing: 'border-box',
          p: 0.5,
        }}>
        {filterApplied && (
          <Box sx={{ display: 'flex', alignItems: 'start', justifyContent: 'center', gap: 0.5, overflow: 'show', zIndex: 99 }}>
            <Iconify icon='carbon:filter-reset' width='15' height='15' />
            <Typography sx={{ fontSize: '11px', '&:hover': { textDecoration: 'underline' } }}>Clear Filters</Typography>
          </Box>
        )}
      </Button>
    </TooltipMui>
  )
}

export default ResetFiltersButton
